import { useValidationYupDocumento } from 'utils/form-validations';
import * as Yup from 'yup';

export const useFormPerfilValidation = () => {
    const { documentoYup } = useValidationYupDocumento(true)

    const FormPerfilYupValidation = Yup.object().shape({
        nome: Yup.string().required('Nome é obrigatório.'),
        cpfcnpj: documentoYup()
    });

    return {
        FormPerfilYupValidation
    };
};